<dx-popup #popup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
    [showCloseButton]="false" title="Löschen" width="800" height="500" (onHidden)="onHidden($event)" (onInitialized)="onInitialized($event)">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view #scrollView class="db-admin-scrollView" *ngIf="!loading && !deleting">
            <div class="db-admin-content-container">
                <div *ngFor="let d of datas; let index_main = index" class="db-admin-content-main">
                    <div class="db-admin-content-header">
                        <strong class="db-admin-content-header-left">{{d.type}}:</strong>
                        <span class="db-admin-content-header-right" [innerHTML]="d.bezeichnung"></span>
                    </div>

                    <div *ngFor="let child of d.childs; let index_child = index" class="db-admin-content-child"
                        [ngClass]="{'text-danger': child.value > 0, 'db-admin-content-child-ok': child.value < 1}">
                        <strong class="db-admin-content-child-left">{{child.type}}:</strong>
                        <span class="db-admin-content-child-right">{{child.value}}</span>
                    </div>
                </div>
            </div>

        </dx-scroll-view>
        <div class="db-admin-loading-container" *ngIf="loading">
            <strong>Daten werden verarbeitet...</strong>
        </div>

        <div class="db-admin-loading-container" *ngIf="deleting">
            <strong>Daten werden gelöscht, das kann mehrere Minuten dauern..</strong>
        </div>
    </div>
    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ disabled: loading,  text: 'Löschen', type: 'danger', stylingMode: 'contained',  icon: 'warning', onClick: onClickDel }">
    </dxi-popup-toolbar-item>

    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ text: 'Abbrechen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onClickClose }">
    </dxi-popup-toolbar-item>
</dx-popup>


<dx-popup #confirmPopup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
    [showCloseButton]="false" title="Bestätigen" width="350" height="auto" (onInitialized)="onInitialized($event)">
    <div *dxTemplate="let data of 'content'">
        <dx-text-box #confirmTextBox placeholder="Bitte das Wort 'LÖSCHEN' zur Bestätigung eingeben"
            [(value)]="confirmText" [isValid]="isConfirmValid"></dx-text-box>
    </div>
    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ disabled: loading || deleting,  text: 'Löschen', type: 'danger', stylingMode: 'contained',  icon: 'warning', onClick: onConfirmClickOk }">
    </dxi-popup-toolbar-item>

    <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ disabled: loading || deleting, text: 'Abbrechen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onConfirmClickClose }">
    </dxi-popup-toolbar-item>
</dx-popup>
